
export enum OcrStatus {
	RQST = "RQST", // 요청중
	CMPL = "CMPL", // 완료
	FAIL = "FAIL", // 판독 실패
	REFL = "REFL" // 판독 재실패
}
